import { render } from "./IimmpactHistory.vue?vue&type=template&id=03265305&scoped=true"
import script from "./IimmpactHistory.vue?vue&type=script&lang=js"
export * from "./IimmpactHistory.vue?vue&type=script&lang=js"

import "./IimmpactHistory.vue?vue&type=style&index=0&id=03265305&lang=scss"
import "./IimmpactHistory.vue?vue&type=style&index=1&id=03265305&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03265305"]])

export default __exports__